import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

export const aiService = {
  chats: (params) => apiClient.get('/admin/chats', { params: cleanParams(params) }),
  chat: (id) => apiClient.get(`/admin/chats/${id}`),
  removeChat: (id) => apiClient.delete(`/admin/chats/${id}`),
  usage: (params) => apiClient.get('/admin/ai/usage', { params: cleanParams(params) }),
  topUsers: (params) => apiClient.get('/admin/ai/usage/top-users', { params: cleanParams(params) }),
  suggestions: (params) => apiClient.get('/admin/ai/suggestions', { params: cleanParams(params) }),
  regenerateSuggestions: (lang) => apiClient.post('/admin/ai/suggestions/regenerate', { lang }),
  getSettings: () => apiClient.get('/admin/ai/settings'),
  updateSettings: (payload) => apiClient.patch('/admin/ai/settings', payload),
};

export default aiService;
